import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
`;

export const Content = styled.div`
  max-height: calc(100vh - 64px - 64px - 32px);
  overflow-y: auto;
`;

export const Tag = styled.div`
  position: relative;

  #tag {
    height: 4px;
    width: 50%;
    background-color: #0384ac;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 4px;
    margin: auto;
  }

  button {
    z-index: 1;
  }
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: #0384ac;
  font-weight: 600;
  text-align: center;
  margin: 30px 0px;
`;

export const List = styled.div`
  button:last-child {
    margin-bottom: 0px !important;
  }
`;
